module.exports = __webpack_public_path__ + "static/media/crown-s.631312e3.svg";